import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import { setDataLayer } from 'shared/actions/globals';
// import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { EVENTS } from 'shared/constants/gtmEvents';
import ModalWrapper from 'shared/components/ModalWrapper/ModalWrapper';

import CreditMarketBanner from '../CreditMarketBanner';
import CommonLeasingButton from '../CommonLeasingButton/CommonLeasingButton';

class CreditMarketButton extends React.Component {
  static propTypes = {
    advert: PropTypes.shape().isRequired,
    eventPostfix: PropTypes.string,
    isNotCleared: PropTypes.bool,
    children: PropTypes.node,
    //
    setDataLayer: PropTypes.func.isRequired,
    intl: PropTypes.shape().isRequired,
  };

  static defaultProps = {
    eventPostfix: '',
    leasingParams: null,
    isNotCleared: false,
    children: null,
  };

  state = {
    showModal: false,
  };

  toggleLeasingModal = event => {
    event.stopPropagation();
    const { eventPostfix } = this.props;
    const showModal = !this.state.showModal;
    this.setState({ showModal });
    const eventName = `creditmarket-consultation-show-form-click${eventPostfix
      ? `-${eventPostfix}`
      : ''}`;
    if (showModal && EVENTS.leasing[eventName]) this.props.setDataLayer(EVENTS.leasing[eventName]);
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { advert, intl, eventPostfix, children } = this.props;
    const PRICE_UAH = advert.is_not_cleared ? '300 000' : '140 000';
    const prefix = intl.formatMessage({ id: 'Профинансируем это авто' });
    const title = `${PRICE_UAH} грн.`;
    return (
      <React.Fragment>
        <CommonLeasingButton
          className="creditmarket"
          onClick={this.toggleLeasingModal}
          prefix={prefix}
          title={title}
        >
          {children}
        </CommonLeasingButton>
        {this.state.showModal &&
          <ModalWrapper toggleModal={this.toggleLeasingModal} show={this.state.showModal}>
            <CreditMarketBanner
              advert={advert}
              modalMode
              onSubmited={this.closeModal}
              eventPostfix={eventPostfix}
            />
          </ModalWrapper>}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setDataLayer: bindActionCreators(setDataLayer, dispatch),
});

export default connect(null, mapDispatchToProps)(injectIntl(CreditMarketButton));



// WEBPACK FOOTER //
// ./src/shared/components/LeasingOnlineBanner/CreditMarketButton/CreditMarketButton.js